import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "@/context/auth-context"
import { FullPageSkeleton } from "@/components/ui/skeleton"
import { isSuperAdmin } from "@/lib/roles"

export function ProtectedRoute({ children, requireAdmin = false, requireSuperAdmin = false }) {
  // initializing = true durante la hidratación inicial al recargar la página
  // (getCurrentUser leyendo Supabase session + localStorage). Sin esperarlo,
  // el componente ve user=null en el primer render y te avienta a /login,
  // tirando la sesión persistente. Hay que esperar a ambos.
  const { user, loading, initializing } = useAuth()
  const navigate = useNavigate()
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (loading || initializing) return

    if (!user) {
      navigate("/login", { replace: true })
      return
    }

    if (requireSuperAdmin && !isSuperAdmin(user)) {
      navigate("/kanban", { replace: true })
      return
    }

    if (requireAdmin && !(user.isAdmin || user.rol === "admin" || isSuperAdmin(user))) {
      navigate("/kanban", { replace: true })
      return
    }

    setIsValidating(false)
  }, [user, loading, initializing, requireAdmin, requireSuperAdmin, navigate])

  if (loading || initializing || isValidating) {
    return <FullPageSkeleton message="Verificando acceso..." />
  }

  if (!user) return null

  return typeof children === "function"
    ? children({ onLogout: () => navigate("/login"), user })
    : children
}




